var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApartment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 13.75V3.25H3.75V0.25H11.25V6.25H14.25V13.75H8.25V10.75H6.75V13.75H0.75ZM2.25 12.25H3.75V10.75H2.25V12.25ZM2.25 9.25H3.75V7.75H2.25V9.25ZM2.25 6.25H3.75V4.75H2.25V6.25ZM5.25 9.25H6.75V7.75H5.25V9.25ZM5.25 6.25H6.75V4.75H5.25V6.25ZM5.25 3.25H6.75V1.75H5.25V3.25ZM8.25 9.25H9.75V7.75H8.25V9.25ZM8.25 6.25H9.75V4.75H8.25V6.25ZM8.25 3.25H9.75V1.75H8.25V3.25ZM11.25 12.25H12.75V10.75H11.25V12.25ZM11.25 9.25H12.75V7.75H11.25V9.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/apartment.797bcda601b77cc7f2b59995c0b18e80.svg";
export { ForwardRef as ReactComponent };